import { render, staticRenderFns } from "./FirstDraftModal.vue?vue&type=template&id=6b2ab991&scoped=true&"
import script from "./FirstDraftModal.vue?vue&type=script&lang=js&"
export * from "./FirstDraftModal.vue?vue&type=script&lang=js&"
import style0 from "./FirstDraftModal.vue?vue&type=style&index=0&id=6b2ab991&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2ab991",
  null
  
)

export default component.exports